 import axios from 'axios';
 // import { AsyncStorage } from '@react-native-async-storage/async-storage';

// const token =  AsyncStorage.getItem('token');
// const header = `Authorization: Bearer ${token}`;

 export default axios.create({
   baseURL: 'https://api.fntpf.ir/',
 });
